import noop from 'lib/function/noop'
import { createReducer } from 'lib/redux/reducerUtils'
import { createContext } from 'react'
import type { ValueOf } from 'type-fest'
import { PRIZES } from './luxAwardPrizes'

export interface LuxAwardModalState {
  currentStep: string
  steps: Array<string>
}

const steps = PRIZES.map((prize) => prize.key)

export const luxAwardInitialState: LuxAwardModalState = { currentStep: 'home', steps: ['home', ...steps] }
export enum LuxAwardModalDispatchActions {
  GO_NEXT = 'GO_NEXT',
  GO_PREVIOUS = 'GO_PREVIOUS',
  GO_HOME = 'GO_HOME',
  GO_TO = 'GO_TO',
}

export type LuxAwardModalDispatchAction = ValueOf<Utils.FullActionMap<{
  [LuxAwardModalDispatchActions.GO_NEXT]: { }
  [LuxAwardModalDispatchActions.GO_PREVIOUS]: { }
  [LuxAwardModalDispatchActions.GO_HOME]: { }
  [LuxAwardModalDispatchActions.GO_TO]: { step: string }
}>>

export const luxAwardModalStateReducer = createReducer<LuxAwardModalState, LuxAwardModalDispatchAction>(
  luxAwardInitialState,
  {
    [LuxAwardModalDispatchActions.GO_HOME]: (_state, _action) => ({
      currentStep: 'home',
    }),
    [LuxAwardModalDispatchActions.GO_TO]: (_state, action) => ({
      currentStep: action.step,
    }),
    [LuxAwardModalDispatchActions.GO_NEXT]: (state, _action) => {
      const currentIndex = state.steps.indexOf(state.currentStep)
      const isLastStep = currentIndex === state.steps.length - 1
      if (!isLastStep) {
        return {
          currentStep: state.steps[currentIndex + 1],
        }
      }
      return state
    },
    [LuxAwardModalDispatchActions.GO_PREVIOUS]: (state, _action) => {
      const currentIndex = state.steps.indexOf(state.currentStep)
      const isFirstStep = currentIndex === 0
      if (!isFirstStep) {
        return {
          currentStep: state.steps[currentIndex - 1],
        }
      }
      return state
    },

  },
)

export const LuxAwardModalStateContext = createContext<LuxAwardModalState>(luxAwardInitialState)
export const LuxAwardModalDispatchContext = createContext<React.Dispatch<LuxAwardModalDispatchAction>>(noop)
